import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AnimatedCharacter from '../AnimatedCharacter';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';
import SenseButton from './SenseButton';
import PushButton from './PushButton';

export default class Slides extends Phaser.Scene {
  static get KEY() { return 'Slides'; }

  create() {
    // console.log('Slides');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.charX = 0;
    this.charY = 0;
    this.currentSlide = 0;
    this.slideOutX = 0;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'LandscapeMainBackground_4x3', this).setOrigin(0, 0);
    this.slideAudio = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.slideInfo = gameData.slideData;
    this.currentSlide = -1;

    this.textSlideContainer = this.add.container();

    this.textBackground = ABCyaPhaser.Images.addImage(0, 0, 'SlideTextBackground', this.textSlideContainer).setOrigin(0, 0);

    this.textDisplay = ABCyaPhaser.Text.addText(0, 0, 50, '0x000000', FontKeys._asapregular, 'SOMETING', this.textSlideContainer, false).setWordWrapWidth(this.textBackground.width - 30);
    this.textDisplay.x = 32;
    this.textDisplay.y = 50;

    this.textSlideContainer.x = this.mid.x * 2;
    this.textSlideContainer.y = 120;

    this.btnNext = new PushButton(this, 'Button', 'ButtonArrow', 8,0,() => {this.nextClick();});
    this.btnNext.x = this.mid.x * 2 - this.btnNext.getBounds().width + 2;
    this.btnNext.y = this.mid.y * 2 - this.btnNext.getBounds().height - 15;

    this.sensesContainer = this.add.container();
    this.sensesButtons = [];
    const len = this.slideInfo.length;
    let item = null; let curX = 0;
    for (let i = 0; i < len; i++) {
      const sense = this.slideInfo[i].slidesense;
      item = new SenseButton(this, sense);
      item.x = curX;
      item.y = -200;
      curX += item.bg.getBounds().width + 26;
      this.sensesButtons.push(item);
      item.displayButton();
      this.sensesContainer.add(item);
    }
    this.sensesContainer.x = 460;
    this.sensesContainer.y = 60;

    this.layoutRatio();
    this.nextSlide();
  }

  nextSlide() {
    if (this.currentSlide < this.slideInfo.length - 1) {
      this.currentSlide++;

      if (this.char) {
        if (this.char.call) this.char.call.destroy();
        this.tweens.killTweensOf(this.char.arms);
        this.char.destroy();
        this.char = null;
      }

      this.char = new AnimatedCharacter(this, gameData.SENSES_CHARACTERS[this.currentSlide]);

      this.char.x = 220;
      this.charX = 220;
      this.char.y = this.mid.y;
      this.charY = this.mid.y;
      this.char.scaleX = 0;
      this.char.scaleY = 0;
      ABCyaPhaser.Tweens.addTween(this.char, 820, { scaleX: 0.8, scaleY: 0.8 }, Phaser.Math.Easing.Quadratic.Out);
      this.textDisplay.text = ABCyaPhaser.Localization.instance.getLocalizedString(this.slideInfo[this.currentSlide].slidetext);
      ABCyaPhaser.Text.resizeFontToFitWidth(this.textDisplay, this.textBackground.width - 30, this.textBackground.height - 100);

      // Set up transition in....
      ABCyaPhaser.Tweens.addTween(this.sensesButtons[this.currentSlide], 320, { y: 0 }, Phaser.Math.Easing.Quadratic.Out);
      this.textSlideContainer.x = this.mid.x * 2;

      ABCyaPhaser.Tweens.addTween(this.textSlideContainer, 800, { x: this.slideOutX }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.slideDisplayed();
      });
    }
    else {
      this.scene.start('Game');
    }
  };

  slideDisplayed() {
    this.btnNext.alpha = 1.0;
    this.sensesButtons[this.currentSlide].select();
    ABCyaPhaser.Audio.playSound(this.slideInfo[this.currentSlide].slideaudio, this.slideAudio);

    this.btnNext.bg.setInteractive();
  };

  nextClick() {
    this.btnNext.bg.disableInteractive();

    if (this.slideAudio) {
      this.slideAudio.stop();
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.removeSlide();
  };

  removeSlide() {
    this.btnNext.alpha = 0.6;

    this.sensesButtons[this.currentSlide].deselect();

    ABCyaPhaser.Tweens.addTween(this.textSlideContainer, 600, { x: this.mid.x * 2 + 20 }, Phaser.Math.Easing.Quadratic.In, () => {
      this.nextSlide();
    });

    this.tweens.killTweensOf(this.char.arms);
    if (this.char.call) this.char.call.destroy();
    ABCyaPhaser.Tweens.addTween(this.char, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      if (this.char.call) this.char.call.destroy();
      this.char.destroy();
      this.char = null;
    });

    if (this.currentSlide + 1 >= this.slideInfo.length) {
      ABCyaPhaser.Tweens.addTween(this.sensesContainer, 400, { y: -111 }, Phaser.Math.Easing.Linear);
      ABCyaPhaser.Tweens.addTween(this.btnNext, 300, { x: this.mid.x * 2 + 100 }, Phaser.Math.Easing.Linear);
    }
  };

  layoutRatio() {
    this.textSlideContainer.scaleX = 1;
    this.textSlideContainer.scaleY = 1.0;
    this.sensesContainer.scaleX = 1;
    this.sensesContainer.scaleY = 1.0;
    this.btnNext.scaleX = 1;
    this.btnNext.scaleY = 1.0;
    this.btnNext.x = this.mid.x * 2 - this.btnNext.getBounds().width + 2;
    this.btnNext.y = this.mid.y * 2 - (this.btnNext.getBounds().height * this.btnNext.scaleY) - 15;
    this.sensesContainer.y = 60;

    this.sensesContainer.x = this.mid.x * 2 - this.sensesContainer.getBounds().width * this.sensesContainer.scaleX;
    this.textSlideContainer.y = this.mid.y - (this.textSlideContainer.getBounds().height * this.textSlideContainer.scaleY) / 2;
    const w = this.textSlideContainer.getBounds().width;
    const slideWidthDif = w - (w * this.textSlideContainer.scaleX);
    this.slideOutX = this.mid.x * 2 - (w - slideWidthDif);

    this.tweens.killTweensOf(this.textSlideContainer);

    this.textSlideContainer.x = this.slideOutX;
  };
}